import { render, staticRenderFns } from "./input-with-info-text.vue?vue&type=template&id=773fd232"
import script from "./input-with-info-text.vue?vue&type=script&lang=js"
export * from "./input-with-info-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports